module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "article"
  }, [_c('p', {
    staticClass: "fwbd mt20 tc"
  }, [_vm._v("委托扣款授权书")]), _vm._v(" "), _c('p', {
    staticClass: "fwbd mt20"
  }, [_vm._v("特别提醒：在您确认签署本授权书之前，请您务必仔细阅读本授权书所有条款，尤其是以粗体及下划线标注的条款，一旦您在贷款人、服务方或其合作方的网站或其他与本贷款相关的软件客户端（以下简称“贷款服务平台”）点击接受本授权书，即意味您已充分理解本授权书所有条款的含义及相应的法律后果，不可撤销地同意您作为借款人作出本授权书的授权内容。")]), _vm._v(" "), _c('p', [_vm._v("授权人：借款人，简称“您”或“本人”；")]), _vm._v(" "), _c('p', [_vm._v("被授权人：贷款人【华瑞银行股份有限公司】（简称“华瑞银行”）、保险人【众安在线财产保险股份有限公司】（简称“众安保险”）、服务方【深圳市汇庄金融服务有限公司】（简称“汇庄金服”）、绑定银行卡账户发放的银行（简称“发卡银行”）。")]), _vm._v(" "), _c('p', {
    staticClass: "txin mt20"
  }, [_vm._v("一、您保证提供给华瑞银行、众安保险、汇庄金服的银行卡账户资料（包括：卡号、姓名、证件号码、预留手机号码等）为您本人持有的真实、完整、准确、合法、有效的银行卡信息，并同意由汇庄金服或众安保险将以上信息送至发卡银行进行核验。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("二、您同意并授权华瑞银行根据您借款还款，您所购买基金、理财等产品的金额，通过支付清算机构以及发卡银行，从您提供的银行卡中扣款。您承诺前述委托扣款视同您本人作出，不得向支付清算机构以及发卡银行提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("三、您同意并授权发卡银行或其他支付清算机构接受华瑞银行或众安保险委托，根据您在出借银行的借款金额，从您提供的银行卡账户中扣款用于还款。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("四、您同意并授权发卡银行或其他支付清算机构接受汇庄金服或其委托方委托，根据您在“华瑞银行·众安保险场景贷业务”（华瑞银行与众安保险合作项下的消费类贷款信用保险服务产品，以下简称“场景贷”）下签署的相关咨询服务协议中约定的咨询服务费及第三方杂费金额，从您提供的银行卡账户中扣款用于缴费。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("五、您同意并授权在您未按时履行还款义务导致保险事故发生，众安保险理赔后对您进行追偿时，由众安保险或其委托方合作的第三方支付公司或银行从您在本行开立的账户或您在本行绑定的他行账户中对您应付的贷款本息（含罚息）进行代扣。您承诺前述委托扣款视同您本人作出，不得向发卡银行及其他代理扣款的支付清算机构提出异议。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("六、因您提供他人银行卡账户资料或虚假信息，或您提供的银行卡账户余额不足或被挂失、冻结、销户等原因而引起的一切损失和法律责任，由您自行承担，与华瑞银行、众安保险或汇庄金服无关。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("七、授权人在指定账户中必须留有足够余额，否则因账户余额不足或不可归责于被授权人或其委托方的任何事由，导致无法及时扣款或扣款错误、失败，责任由授权人自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("八、如因第三方支付公司或银行限额、系统故障等原因导致扣款失败，委托扣款方将通知授权人，授权人需在2日内将该笔款项一次性主动划款至对应扣款人指定对公账户。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("九、因支付清算机构或发卡银行原因导致扣款错误或延迟，给您造成损失的，由过错方承担责任，委托扣款方将协助您向其追究相应责任。")]), _vm._v(" "), _c('p', {
    staticClass: "txin"
  }, [_vm._v("十、本授权书自授权人使用电子签章确认之日起生效，至授权人在“场景贷”业务下所有借款本金、利息及其他约定费用等全部偿还完毕时终止。")]), _vm._v(" "), _c('p', {
    staticClass: "txin fwbd"
  }, [_vm._v("客户确认：本人已认真阅读本协议，在完全理解本协议的情况下，同意本协议的全部内容，本人同意承担由此带来的一切法律后果。")]), _vm._v(" "), _c('p', {
    staticClass: "mt20 fwbd"
  }, [_vm._v("授权人：（电子签章）")]), _vm._v(" "), _c('p', [_vm._v("【系统填充】年【系统填充】月【系统填充】日")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c7543c5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/paycontract.vue
// module id = 215
// module chunks = 0